import React, { Component, Fragment } from 'react'
import { Query, Mutation } from 'react-apollo'

import { SELF_QUERY } from '../../queries'
import { EDIT_SELF, UPDATE_PASSWORD } from '../../mutations'

import TabBreadcrumb from '../../components/TabBreadcrumb/'
import Form from '../../components/Form/'
import Loader from '../../components/Loader/'
import Error from '../../components/Error/'
import helpers from '../../helpers'

import withHeaderFooter from '../../wrapper/withHeaderFooter'

import { Container } from '../../styles/defaults.js'
import { MiniContainer, Title } from './styles.js'

class Settings extends Component {
  constructor(props) {
    super(props)
    this.state = {
      tabOne: true,
      currentTab: 'Persoonlijke gegevens'
    }
  }

  showPassword() {
    this.setState({
      tabOne: false,
      currentTab: 'Wachtwoord'
    })
  }

  showPersonal() {
    this.setState({
      tabOne: true,
      currentTab: 'Persoonlijke gegevens'
    })
  }

  render() {
    const { tabOne, currentTab } = this.state

    return (
      <Query query={SELF_QUERY}>
        {({ data, loading, error }) => {
          if (loading) return <Loader from="25%" to="100%" fixed />
          if (error) return <Error error="de gebruikersgegevens" />

          const user = data.self
          let editProfile = user.permissions.includes('EDIT_PROFILE') || user.role === 'MANAGER'
          Object.keys(user).map((key, index) => {
            if (user[key] === null) {
              user[key] = ''
            }
            return null
          })

          let personalFormFields = [
            { name: 'firstName', label: 'Voornaam*', value: user.firstName, type: 'text', required: 'required' },
            {
              name: 'insertion',
              label: 'Tussenvoegsel',
              value: user.insertion,
              type: 'select', 
              options: helpers.getInsertions()
            },
            { name: 'lastName', label: 'Achternaam*', value: user.lastName, type: 'text', required: 'required' },
            { name: 'email', label: 'E-mailadres*', value: user.email, type: 'email', required: 'required' },
            { name: 'phone', label: 'Telefoonnummer*', value: user.phone, type: 'tel', required: 'required' },
            { name: 'altPhone', label: 'Alternatief telefoonnummer', value: user.altPhone, type: 'tel' }
          ]

          let passwordFormFields = [
            { name: 'oldPassword', label: 'Huidig wachtwoord', value: '', type: 'password' },
            { name: 'newPassword', label: 'Nieuw wachtwoord', value: '', type: 'password' }
          ]

          return (
            <Fragment>
              <TabBreadcrumb
                parent="Instellingen"
                title={currentTab}
                one="Persoonlijke gegevens"
                oneShort="Gegevens"
                two="Wachtwoord"
                twoShort="Wachtwoord"
                onClickOne={this.showPersonal.bind(this)}
                onClickTwo={this.showPassword.bind(this)}
              />

              <Container>
                {tabOne ? (
                  <Fragment>
                    {editProfile ? (
                      <Mutation
                        mutation={EDIT_SELF}
                        update={(store, { data: { updateSelf } }) => {
                          const data = store.readQuery({ query: SELF_QUERY })
                          Object.keys(updateSelf).map((key, index) => {
                            if (data.self[key] !== updateSelf[key]) {
                              data.self[key] = updateSelf[key]
                            }
                            return null
                          })

                          store.writeQuery({
                            query: SELF_QUERY,
                            data
                          })
                        }}
                      >
                        {(editUser, { data, loading, error }) => (
                          <MiniContainer>
                            <Title>Persoonlijke gegevens</Title>
                            <Form
                              fields={personalFormFields}
                              submitText="Opslaan"
                              onSubmitForm={editUser}
                              data={data}
                              loading={loading}
                              error={error}
                              userImage
                            />
                          </MiniContainer>
                        )}
                      </Mutation>
                    ) : (
                      <Container style={{ textAlign: 'center' }} mt mb>
                        Onvoldoende rechten om uw profiel te wijzigen
                      </Container>
                    )}
                  </Fragment>
                ) : null}

                {!tabOne ? (
                  <Fragment>
                    {editProfile ? (
                      <Mutation mutation={UPDATE_PASSWORD}>
                        {(updatePassword, { data, loading, error }) => (
                          <MiniContainer micro>
                            <Title>Wachtwoord veranderen</Title>
                            <Form
                              fields={passwordFormFields}
                              submitText="Opslaan"
                              onSubmitForm={updatePassword}
                              data={data}
                              loading={loading}
                              error={error}
                              passwordStrength
                            />
                          </MiniContainer>
                        )}
                      </Mutation>
                    ) : null}
                  </Fragment>
                ) : null}
              </Container>
            </Fragment>
          )
        }}
      </Query>
    )
  }
}

export default withHeaderFooter(Settings, '', 'black')



// WEBPACK FOOTER //
// ./src/views/Settings/index.js